import React, { useEffect, useRef } from "react";

// Hält alle CSS-Animationen im Inneren an, solange der Bereich nicht im Viewport ist
// (Regel in UiGlobalStyles.js: [data-aof-offscreen="true"] … animation-play-state: paused).
// Auf der Startseite laufen >20 Endlos-Animationen (Hero, Battle, Furz des Tages …);
// ohne Pause rechnet der Browser sie auch außerhalb des Bildschirms weiter – das kostet
// vor allem auf Handys CPU und Akku. Das Attribut wird direkt am DOM gesetzt, damit
// Scrollen keine React-Re-Renders auslöst.
export default function PauseWhenOffscreen({ children, as: Tag = "div", ...rest }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        el.dataset.aofOffscreen = entry.isIntersecting ? "false" : "true";
      },
      { rootMargin: "100px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return <Tag ref={ref} {...rest}>{children}</Tag>;
}
